import React, { useState, useRef } from 'react';
import reactStringReplace from 'react-string-replace';

import { Links } from '@/utils/constants';
import { BorderLink, Icon, Name } from '@/components/general';

import * as styled from './Feature.styled';

interface IFeature {
  question: string;
  answer: string;
  linkReg?: RegExp;
  links?: Links | string[];
  $mainPage?: boolean;
  style?: React.CSSProperties;
}

export const Feature: React.FC<IFeature> = ({
  question,
  answer,
  linkReg,
  links,
  $mainPage,
  style,
}) => {
  const [openFeature, setOpenFeature] = useState('');

  const openFeatureTextRef = useRef(null);

  const isEmpty = answer === '' || answer === '-' || answer === ' ';

  return (
    <styled.FeaturesListItem
      onClick={
        !isEmpty
          ? !openFeature
            ? () => setOpenFeature(question)
            : openFeature === question
            ? () => setOpenFeature('')
            : () => setOpenFeature(question)
          : undefined
      }
      $mainPage={$mainPage}
      $isEmpty={isEmpty}
      style={style}
    >
      <styled.TitleBox>
        <styled.ListItemBox>
          {!$mainPage && (
            <styled.CheckIconBox>
              <Icon name={Name.GENERAL_FEATURE_CHECK_MARK} />
            </styled.CheckIconBox>
          )}
          <styled.FeatureTitle>{question}</styled.FeatureTitle>
        </styled.ListItemBox>
        {!isEmpty && (
          <styled.ArrowBox open={openFeature === question}>
            <Icon
              name={
                $mainPage
                  ? Name.GENERAL_FEATURE_ARROW
                  : Name.GENERAL_FEATURE_ARROW_SECOND
              }
              width={$mainPage ? 17 : 24}
              height={$mainPage ? 10 : 24}
            />
          </styled.ArrowBox>
        )}
      </styled.TitleBox>
      {!isEmpty && (
        <styled.FeatureOpen
          open={openFeature === question}
          $adaptiveHeight={
            openFeatureTextRef?.current?.getBoundingClientRect()?.height
          }
          $mainPage={$mainPage}
        >
          <styled.FeatureText ref={openFeatureTextRef}>
            {reactStringReplace(answer, linkReg, (match, i) => {
              const index = Math.floor(i / 2);
              return (
                <BorderLink
                  key={`feature-${index}`}
                  to={links[index]}
                  as={links[index].includes('mailto') ? 'a' : undefined}
                  href={
                    links[index].includes('mailto') ? links[index] : undefined
                  }
                >
                  {match}
                </BorderLink>
              );
            })}
          </styled.FeatureText>
        </styled.FeatureOpen>
      )}
    </styled.FeaturesListItem>
  );
};
